<div class="container">

  <app-header-dialog [iconName]="'attach_money'">
    Lotes - Regras
  </app-header-dialog>

  <form [formGroup]='priceForm' autocomplete="off">

    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>attach_money</mat-icon>
          <div>Regras</div>
        </ng-template>

        <div class='tab-content'>

          <div class="box-left">

            <mat-form-field class="name-width" appearance="outline">
              <mat-label>Grupo</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
                autocomplete="off">
              <mat-error *ngIf="entityForm.controls.name.hasError('required')">
                Informe um grupo
              </mat-error>
            </mat-form-field>

            <div>
              <mat-form-field class="value-width" appearance="outline">
                <mat-label>Valor</mat-label>
                <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.value"
                  autocomplete="off">
                <mat-error *ngIf="entityForm.controls.value.hasError('required')">
                  Informe um valor
                </mat-error>
              </mat-form-field>

              <mat-form-field class="value-width-pix" appearance="outline">
                <mat-label>Valor PIX</mat-label>
                <input matInput type="number" [errorStateMatcher]="matcher"
                  [formControl]="entityForm.controls.value_pix" autocomplete="off">
                <mat-error *ngIf="entityForm.controls.value_pix.hasError('required')">
                  Informe um valor
                </mat-error>
              </mat-form-field>
            </div>

            <div>
              <mat-form-field class="value-width" *ngIf='isPartner' appearance="outline">
                <mat-label>Inadimplente</mat-label>
                <input matInput type="number" [errorStateMatcher]="matcher"
                  [formControl]="entityForm.controls.value_defaulting" autocomplete="off">
                <mat-error *ngIf="entityForm.controls.value_defaulting.hasError('required')">
                  Informe um valor
                </mat-error>
              </mat-form-field>

              <mat-form-field class="value-width-pix" *ngIf='isPartner' appearance="outline">
                <mat-label>Inadimplente PIX</mat-label>
                <input matInput type="number" [errorStateMatcher]="matcher"
                  [formControl]="entityForm.controls.value_defaulting_pix" autocomplete="off">
                <mat-error *ngIf="entityForm.controls.value_defaulting_pix.hasError('required')">
                  Informe um valor
                </mat-error>
              </mat-form-field>

            </div>


          </div>

          <div class="box-right">

            <div class="cat-wrapper">

              <mat-form-field class="category-width" appearance="outline">
                <mat-label>Categoria</mat-label>

                <mat-select (ngModelChange)='selectCategory($event)' [errorStateMatcher]="matcher"
                  [formControl]="priceForm.controls.category_id">
                  <mat-option *ngFor="let subcat of arraySubCategories" [value]="subcat.id">
                    {{ subcat.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="priceForm.controls.category_id.hasError('required')">
                  Selecione uma categoria
                </mat-error>
              </mat-form-field>

              <button mat-raised-button (click)='addSubCategory()' style="height: 36px; margin-top: 10px;">
                <mat-icon class='icon-add'>add_circle_outline</mat-icon>
              </button>

            </div>

            <!-- TABLE -->
            <mat-table [dataSource]="selectedSubCategoriesDataSource" matSort
              style='height:280px; overflow:auto; margin: 0;'>

              <!-- icon Column -->
              <ng-container matColumnDef="icon">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-icon style='font-size:1.4em; color:rgba(0,0,0,.7);'>attach_money</mat-icon>
                </mat-cell>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef> Categorias </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.name }} </mat-cell>
              </ng-container>


              <!-- delete Column -->
              <ng-container matColumnDef="delete">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <a mat-button (click)='removeSubCategory(element)' style='background-color: whitesmoke;'>
                    <mat-icon class="icon-delete">delete_outline
                    </mat-icon>
                  </a>
                </mat-cell>
              </ng-container>

              <!-- Header -->
              <mat-header-row *matHeaderRowDef="displayedCategoryPricesColumns"></mat-header-row>

              <!-- Row -->
              <mat-row *matRowDef="let row; columns: displayedCategoryPricesColumns;">
              </mat-row>

            </mat-table>
            <!-- END TABLE -->

          </div>

        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>attach_file</mat-icon>
          <div>Documentos</div>
        </ng-template>

        <div class='tab-content'>

          <div class="doc-wrapper">

            <div class="doc-header">
              <div>
                Documentos
              </div>
              <a mat-button (click)="openDocDialog(null)" style='width:60px;'>
                <mat-icon color='primary'>add_circle_outline</mat-icon>
              </a>
            </div>

            <div class="doc-box" *ngIf="currentCategoryPrice">
              <div *ngFor="let item of currentCategoryPrice.docList">
                <div style="display: flex; justify-content: space-between;">
                  <div style='width:100%;'>
                    {{item.doc}}
                  </div>
                  <a mat-button (click)="openDocDialog(item)" style='width:60px;'>
                    <mat-icon class='icon-info'>info_outline</mat-icon>
                  </a>
                  <a mat-button (click)="removeDocument(item.id)" style='width:60px;'>
                    <mat-icon class='icon-delete'>delete_outline</mat-icon>
                  </a>
                </div>
                <hr>
              </div>

            </div>

          </div>

        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>folder_off</mat-icon>
          <div>Antigos</div>
        </ng-template>

        <div class='tab-content'>

          <div>

            <div class='check-box'>
              <mat-checkbox color='primary' [formControl]="entityForm.controls.requires_doc">
                Requer Documentação
              </mat-checkbox>
            </div>

            <mat-form-field class='list-doc-width' appearance="outline">
              <textarea style='width: 100%; height:100px; border: solid 1px silver; padding:5px;' matInput
                [errorStateMatcher]="matcher" [formControl]="entityForm.controls.list_doc" placeholder="Documentos"
                autocomplete="off">
                        </textarea>
            </mat-form-field>

          </div>

        </div>

      </mat-tab>

    </mat-tab-group>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button mat-raised-button (click)='update()' *ngIf='isEdit' [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button mat-raised-button (click)='insert()' *ngIf='!isEdit'  [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>